const callBridge = (msg)=>{
    // console.log('callBridge target',window.parent)
    try {
        window.parent.postMessage(msg,'*')
        window.opener?.postMessage(msg,'*')
    } catch (error) {
        console.warn('callBridge -> error', '  '+JSON.stringify(msg))
        window.parent.postMessage(msg,'*')
        window.opener?.postMessage(msg,'*')
    }
}
export const getInfo = ()=>{
    const msg = {
        belong:'ym-assembled',
        functions: 'getInfo'
    }
    callBridge(msg)
}
export const closePage = ()=>{
    const msg = {
        belong:'ym-assembled',
        functions: 'leave'
    }
    callBridge(msg)
}
export const openURL = (url)=>{
    const msg = {
        functions: 'outside',
        params: {
            wz:url
        }
    }
    callBridge(msg)
}
export  const openApplePay=()=>{
    const msg = {
        functions: 'p2a',
        params:{}
    }
    callBridge(msg)
}

export const tellResult  = (result,data)=>{
    const msg = {
        belong: 'ym-assembled',
        functions: 'result',
        params: {result,data}
    }
    callBridge(msg)
}
